import Skeleton from 'components/Skeleton';
import useStyles from './styles';

const CarouselSkeleton = () => {
  const styles = useStyles();

  return (
    <div className={styles.skeletonCarousel} data-testid="carousel-skeleton">
      <Skeleton className={styles.skeletonSlide} />
      <Skeleton className={styles.skeletonSlide} />
      <Skeleton className={styles.skeletonSlide} />
    </div>
  );
};

export default CarouselSkeleton;
